import { RR_ALERT_TYPE } from './alert-type.enum';

export class RRAlertModel {
  type: RR_ALERT_TYPE;
  message: string;
  timeout?: number = 3000;
  dismissible?: boolean = true;
}
